import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const CategorySelector = ({ categories, formData, onToggle }) => (
  <Card>
    <CardHeader>
      <CardTitle>Categorias *</CardTitle>
    </CardHeader>
    <CardContent className="space-y-3">
      <p className="text-sm text-slate-500 mb-2">Selecione uma ou mais categorias para este artigo</p>
      <div className="space-y-2">
        {categories.map((category) => {
          const isSelected = (formData.category_ids || []).includes(category.id) || formData.category_id === category.id;
          const isPrimary = formData.category_id === category.id;
          return (
            <label
              key={category.id}
              className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                isSelected ? 'border-primary bg-primary/5' : 'border-slate-200 hover:border-slate-300'
              }`}
            >
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => onToggle(category.id)}
                className="w-4 h-4 text-primary rounded border-slate-300"
              />
              <span className={`flex-1 ${isSelected ? 'text-slate-900 font-medium' : 'text-slate-700'}`}>
                {category.name}
              </span>
              {isPrimary && (
                <span className="text-xs bg-primary/10 text-primary px-2 py-0.5 rounded">Principal</span>
              )}
            </label>
          );
        })}
      </div>
      {(formData.category_ids?.length > 1 || (formData.category_id && formData.category_ids?.length >= 1)) && (
        <p className="text-xs text-slate-500 mt-2">A primeira categoria selecionada será a principal</p>
      )}
    </CardContent>
  </Card>
);
